// @flow

import styled from 'styled-components';
import Radio from './radio';
import type { Theme } from '../../../../types';

const StyledInput = styled<any, Theme>('input')`
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;

  &:focus + ${Radio} { /* stylelint-disable-line */
    outline: none;
    box-shadow: 0 0 8px 0 ${props => props.theme.form.focusColor};
  }
`;

export default StyledInput;
